import type { ButtonHTMLAttributes, PropsWithChildren } from "react";
import { Link } from "react-router-dom";

type Props = PropsWithChildren<{
  to?: string;
  tone?: "fire" | "sea" | "gold" | "violet";
  className?: string;
}> & Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children">;

export function GameButton({ to, tone = "fire", className = "", children, ...buttonProps }: Props) {
  const classes = `game-button game-button--${tone} ${className}`.trim();
  if (to) return <Link className={classes} to={to}>{children}</Link>;
  return <button className={classes} {...buttonProps}>{children}</button>;
}
